/* @flow */
import UsersInviteModal from './UsersInviteModal';

export default UsersInviteModal;
